<template>
  <div class="time-and-priorities-manager p-5">
    <h3 class="m-0">Optimizer Settings and Auto-Planning</h3>

    <el-dropdown @command="handleDropdownCommand" class="my-3">
      <el-button type="primary" style="margin-right: 0.5em">
        Add collection<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="addTimeslotCollection">
          <i class="el-icon-circle-plus-outline"></i> Add timeslot collection
        </el-dropdown-item>
        <el-dropdown-item command="connectGoogleCalendar" divided>
          <i class="el-icon-circle-plus-outline"></i> Connect google calendar
        </el-dropdown-item>
        <el-dropdown-item command="addSpecialTimeslotCollectionBlocker" divided>
          <i class="el-icon-circle-plus-outline"></i> Add blockers
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-button type="primary" plain @click="onGoToManageWeek" style="float: right">
      <i class="el-icon-date"></i> Edit regular timeslots
    </el-button>

    <template v-if="page_ready">

      <TimeslotCollectionMultiDragList mode="commitment" />

    </template>
    <template v-else>
      <div class="content-loading">
        Loading...
      </div>
    </template>

    <template v-if="timeslot_collection_list.length === 0">
      <!-- TODO: Move? -->
      <div class="no-timeslot-info">
        You don't have a life area/timeslot collection defined yet.<br>
        <span style="font-size: 10pt">Create one with 'Add collection' &rarr; 'Add timeslot collection'.</span>
      </div>
    </template>

    <div v-if="SHOW_DEBUG" style="background-color: white">
      <!-- <pre>timeslot_collection_list.map: {{ timeslot_collection_list.map(item => item.name) }}</pre> -->
      <!-- <pre>get_tsc_selected: {{get_tsc_selected}}</pre> -->
      <!-- <pre>has_conflict_list: {{has_conflict_list}}</pre> -->
      <!-- <pre>{{aggregated_hours}}</pre> -->
      <!-- <pre>{{flattened_calendar_events}}</pre> -->
      <!-- <pre>{{flattened_calendar_data_all}}</pre> -->
      <!-- <pre>{{available_timeslot_collections}}</pre> -->
    </div>

  </div>
</template>

<script>
import TimeslotCollectionMultiDragList from './Timeslots/TimeslotCollectionMultiDragList';

/* TODO IDEA:
   Gif Tooltip: Explain calendar event creation via Gif
   on mouse hover
*/

export default {
  data() {
    return {
      page_ready: false
    }
  },
  mounted() {
    setTimeout( () => { this.page_ready = true }, 200) // HACK !!!!
  },
  computed: {
    timeslot_collection_list() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    }
  },
  methods: {
    connectGoogleCalendar() {
      console.log("connectGoogleCalendar");
      this.$api.timeslot_collection_add_to_user({
        tscType: 'GOOGLE',
        additionData: {
          // TODO FROM MODAL?
        }
      });
    },

    addSpecialTimeslotCollectionBlocker() {
      console.log("addSpecialTimeslotCollectionBlocker");
      this.$api.timeslot_collection_add_to_user({
        tscType: 'BLOCKER'
      });
    },

    addTimeslotCollection(event) {
      console.log("addTimeslotCollection", event);
      this.$api.timeslot_collection_add_to_user();
    },

    handleDropdownCommand(command) {
      this[command]();
    },

    onGoToManageWeek() {
      this.$router.push('/calendar/manage-time-and-priorities')
    }
  },
  components: {
    TimeslotCollectionMultiDragList,
  }
}
</script>

<style>
/* no tsc created */
.no-timeslot-info {
  color: #d5d5d5;
  font-style: oblique;
  font-size: 18pt;
  text-align: center;
  width: 100%;
  margin: 2em auto;
  line-height: 1.3;
}
.time-and-priorities-manager {
}
.time-and-priorities-manager .content-loading {
  height: 200px;
  line-height: 200px;
  font-weight: bold;
  text-align: center;
  color: gray;
}
.time-and-priorities-manager .timeslot-collection-draggable {
  margin-right: 0.5em;
  min-width: 270px;

  max-height: calc(100vh - 220px);
  overflow: auto;
}
</style>
